import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { addModal, removeModal } from '@state-mgmt/slices/appSlice';
import { DeleteUploadConfirmationModal } from '@components/DeleteUploadConfirmationModal';

export const useDeleteUploadConfirmationModal = () => {
  const modalKey = 'delete-upload-confirmation-modal';
  const dispatch = useDispatch();

  const onClose = useCallback(
    () => {
      
      dispatch(removeModal({ key: modalKey }));
    },
    [dispatch]
  );

  const displayModal = useCallback(
    (onDelete: () => void) => {
      const children = <DeleteUploadConfirmationModal  onClose={onClose} onDelete={onDelete} />;
      dispatch(addModal({ key: modalKey, props: { visible: true, children, onClose } }));
    },
    [dispatch, onClose]
  );

  return { displayModal };
};
